import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { NvDesignLibraryModule } from '../../../nvps-libraries/design/nv-design-library.module';
import { NvMatTooltipModule } from '../components/nv-mat-tooltip/nv-mat-tooltip.module';
import { MaterialModule } from '../modules/material.module';
import { BaseModalComponent } from './base-modal.component';

@NgModule({
  declarations: [BaseModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    MaterialModule,
    MatDialogModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NvMatTooltipModule,
    NvDesignLibraryModule,
  ],
  exports: [BaseModalComponent],
  providers: [],
  entryComponents: [],
})
export class BaseModalModule {}
